import UserInActiveTable from 'components/Tables/UserInActiveTable';
import React from 'react';
import users from 'services/users';
import { getColumn } from '../helper';
import { useHideModal, useShowModal } from 'hooks';
import ModalBody from './ModalBody';
import { setModalLoading } from 'redux/modules/modals/actions';
import { useDispatch } from 'react-redux';
import { Empty, Pagination } from 'antd';
import { NoData, UsersWrapper } from '../style';

const UserInActive = ({
  allUsers,
  refreshData,
  usersDataTotal,
  usersPageCount,
  setUsersPageCount,
  setUserLimit,
  userLimit,
}) => {
  const { showBlured } = useShowModal();
  const { hideModal } = useHideModal();
  const dispatch = useDispatch();

  const handleClick = (id) => {
    showBlured({
      title: 'Ҳолатни ўзгартириш',
      maxWidth: '400px',
      height: '600px',
      withHeader: false,
      body: () => <ModalBody id={id} handleSubmit={handleSubmit} />,
    });
  };

  const handleSubmit = (id, value) => {
    dispatch(setModalLoading(true));
    const newData = {
      start: value?.date[0],
      end: value?.date[1],
    };

    users
      .userInActive(id, newData)
      .then(() => {
        hideModal();
        refreshData();
      })
      .catch((err) => console.log(err))
      .finally(() => {
        dispatch(setModalLoading(false));
      });
  };

  const tableHeader = getColumn({ handleClick });

  const onShowSizeChange = (_, pageSize) => {
    setUserLimit(pageSize);
  };

  return allUsers.length ? (
    <UsersWrapper>
      <UserInActiveTable headers={tableHeader} data={allUsers} />
      <div className='pagination'>
        <Pagination
          current={usersPageCount}
          total={usersDataTotal}
          onChange={(page) => setUsersPageCount(page)}
          onShowSizeChange={onShowSizeChange}
          defaultPageSize={userLimit}
          showSizeChanger
        />
      </div>
    </UsersWrapper>
  ) : (
    <NoData>
      <Empty description={<h1>Маълумот топилмади!</h1>} />
    </NoData>
  );
};

export default React.memo(UserInActive);
